import React from 'react'
import Structure from '../components/layout/Structure'

const Skills = () => {
  return (
    <Structure>
      Skills
    </Structure>
  )
}

export default Skills